import { render } from "./AppUpdateDialog.vue?vue&type=template&id=ed2a2702&scoped=true"
import script from "./AppUpdateDialog.vue?vue&type=script&lang=js"
export * from "./AppUpdateDialog.vue?vue&type=script&lang=js"

import "./AppUpdateDialog.vue?vue&type=style&index=0&id=ed2a2702&lang=css"
import "./AppUpdateDialog.vue?vue&type=style&index=1&id=ed2a2702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2a2702"]])

export default __exports__